import { KendoBaseComponent, KendoBaseInputComponent } from '@progress/kendo-base-components-vue-wrapper'
import NumericTextBoxProps from './NumericTextBoxProps'


export default {
    props: NumericTextBoxProps,
    mixins: [
        KendoBaseComponent,
        KendoBaseInputComponent
    ],
    mounted() {
        var that = this
        kendo.jQuery(that.$el).kendoNumericTextBox(that.widgetOptions)

        that.$emit('kendowidgetready', that.kendoWidget())

        that.kendoWidget().bind('change', function(){
            that.$emit('changemodel', that.$refs.valueInput.value)
        })

        that.kendoWidget().bind('spin', function(){
            that.$emit('changemodel', that.$refs.valueInput.value)
        })
    },
    methods: {
        kendoWidget() {
            return kendo.jQuery(this.$el).getKendoNumericTextBox()
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-inputs-vue-wrapper/src/KendoNumericTextBox/KendoNumericTextBoxMixin.js